export enum InventoryType {
  actual = 'actual',
  incoming = 'incoming',
  outgoing = 'outgoing',
}
